import { render, staticRenderFns } from "./FullLoading.vue?vue&type=template&id=584c3c64&scoped=true&"
import script from "./FullLoading.vue?vue&type=script&lang=ts&"
export * from "./FullLoading.vue?vue&type=script&lang=ts&"
import style0 from "./FullLoading.vue?vue&type=style&index=0&id=584c3c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c3c64",
  null
  
)

export default component.exports